// extracted by mini-css-extract-plugin
export var chevron = "_kf-4";
export var chevronExpanded = "_kf-5";
export var row = "_kf-0";
export var rowBody = "_kf-6";
export var rowDescription = "_kf-7";
export var rowHeader = "_kf-1";
export var rowTitle = "_kf-2";
export var rowTitleComplete = "_kf-3";